import { render, staticRenderFns } from "./FlightBoxThreeChildApp.vue?vue&type=template&id=15fa2946&scoped=true"
import script from "./FlightBoxThreeChildApp.vue?vue&type=script&lang=js"
export * from "./FlightBoxThreeChildApp.vue?vue&type=script&lang=js"
import style0 from "./FlightBoxThreeChildApp.vue?vue&type=style&index=0&id=15fa2946&prod&lang=less&scoped=true"
import style1 from "./FlightBoxThreeChildApp.vue?vue&type=style&index=1&id=15fa2946&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fa2946",
  null
  
)

export default component.exports